// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Printer from "@insite/mobius/Icons/Printer";
import dataTableStyles from "@steiner/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { tableStyles } from "@steiner/App/Widgets/OpenBids/OpenBidsTable";
import { hideElementOnPrint, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

tableStyles.notFoundMessage = {
    ...dataTableStyles.noResultsText,
};

tableStyles.customerInfoContainer = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        column-gap: 32px;
        margin-bottom: 12px;
        margin-top: 12px;
        ${hideElementOnPrint}
        ${xScreen("lte", "md")} {
            flex-direction: column;
            row-gap: 8px;
        }
    `,
};

tableStyles.dataTable = {
    ...dataTableStyles.dataTable,
};

tableStyles.customerInfo = {
    size: 14,
    lineHeight: "22px",
};

tableStyles.printBidsLink = {
    typographyProps: {
        size: 12,
        lineHeight: "15px",
    },
    icon: {
        position: "left",
        iconProps: {
            src: Printer,
            size: 14,
            css: css`
                margin-right: 6px;
                opacity: 0.66;
            `,
        },
    },
    css: css`
        margin-left: auto;
        justify-content: end;
    `,
};

tableStyles.spinner = {
    css: css`
        margin: auto;
    `,
};

 tableStyles.centeringWrapper = {
    css: css`
        height: 300px;
        display: flex;
        align-items: center;
    `,
};